interface SectionHeadProps {
  kicker: string;
  title: string;
  more?: string;
  id?: string;
}

export default function SectionHead({ kicker, title, more, id }: SectionHeadProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div>
        <p className="mb-1.5 text-xs font-bold uppercase tracking-widest text-accent-700">{kicker}</p>
        <h2 id={id} className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
      </div>
      {more && (
        <a
          href={more}
          className="shrink-0 cursor-pointer whitespace-nowrap rounded-full border border-background-200 bg-background-100 px-3 py-1.5 text-xs font-medium text-foreground-600 transition hover:border-primary-300 hover:text-primary-700"
        >
          查看更多 <i className="ri-arrow-right-s-line" />
        </a>
      )}
    </div>
  );
}